import React, { useCallback } from 'react';

import { useRecordContext } from 'react-admin';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import WarningIcon from '@mui/icons-material/Warning';

import useDownloadDocument from '../../hooks/useDownloadDocument';

const styles = {
  warningContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.5rem',
    color: '#f44336',
  },
  warningIcon: {
    marginRight: '0.25rem',
    fontSize: '1.2rem',
  },
};

const AnnualTaxReportDownloadButton = () => {
  const record = useRecordContext();

  const { mutate: getAnnualTaxReport } = useDownloadDocument({
    path: `download/user/${record.id}/annual-tax-report`,
    errorMessage: 'Could not retrieve annual tax report',
  });

  const onClick = useCallback(() => {
    getAnnualTaxReport();
  }, [getAnnualTaxReport]);

  return (
    <div>
      {record.hasMigratedAccounts && (
        <div style={styles.warningContainer}>
          <WarningIcon style={styles.warningIcon} />
          <Typography variant="body2" color="error">
            This user has migrated accounts
          </Typography>
        </div>
      )}
      <Button
        size="small"
        variant="contained"
        color="primary"
        onClick={onClick}
      >
        Download annual tax report
      </Button>
    </div>
  );
};

export default AnnualTaxReportDownloadButton;
